// src/hooks/useRolePermission.js
import { useState, useEffect } from 'react';

// Định nghĩa quyền dựa trên bảng tài liệu
const ROLES = {
    BANK_ADMIN: "BANK_ADMIN",
    BANK_CREATE: "BANK_CREATE",
    BANK_VIEW: "BANK_VIEW",
    BANK_APPROVE: "BANK_APPROVE"
};

export const useRolePermission = () => {
    const [role, setRole] = useState("");

    useEffect(() => {
        // Lấy role từ localStorage (giả sử bạn lưu key là "role")
        const storedRole = localStorage.getItem("role") || "";
        setRole(storedRole);
    }, []);

    // Logic kiểm tra quyền dựa trên bảng Excel/Ảnh
    const permissions = {
        // ADMIN: Xem tất cả, nhưng KHÔNG tạo/sửa/xóa/duyệt
        // VIEW: Chỉ xem, KHÔNG tạo/sửa/xóa/duyệt
        // APPROVE: Chỉ duyệt, KHÔNG tạo/sửa/xóa
        // CREATE: Được tạo/sửa/xóa, KHÔNG duyệt
        
        canCreate: role === ROLES.BANK_CREATE,
        
        // Theo ảnh: "Thêm/sửa/xoá đại lý" chỉ tích ở cột Create
        canEdit: role === ROLES.BANK_CREATE, 
        
        // Theo ảnh: "Thêm/sửa/xoá đại lý" chỉ tích ở cột Create
        canDelete: role === ROLES.BANK_CREATE,
        
        // Theo ảnh: "Duyệt thông tin thay đổi", "Duyệt yêu cầu" tích ở Approve
        canApprove: role === ROLES.BANK_APPROVE,
        
        // Admin, View, Create, Approve đều có quyền xem (nhưng Admin/View không check branch)
        canView: [ROLES.BANK_ADMIN, ROLES.BANK_CREATE, ROLES.BANK_VIEW, ROLES.BANK_APPROVE].includes(role),
    };

    return { role, permissions };
};